import { useState } from "react";
import { FileDown } from "lucide-react";
import { api, formatApiErrorDetail } from "../lib/api";
import { toast } from "sonner";

export default function ExportExcelButton({ endpoint, filename, params, label = "Exportar Excel", testid }) {
  const [busy, setBusy] = useState(false);

  async function onClick() {
    setBusy(true);
    try {
      const resp = await api.get(endpoint, { params, responseType: "blob" });
      const url = URL.createObjectURL(resp.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success("Exportação concluída");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Não foi possível exportar");
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={busy}
      data-testid={testid || "export-xlsx-btn"}
      className="inline-flex items-center gap-2 bg-white text-neutral-900 border border-zinc-200 hover:border-[#16A34A] hover:text-[#15803D] rounded-sm px-4 py-2.5 font-manrope font-medium text-sm transition-colors disabled:opacity-60"
    >
      <FileDown className="w-4 h-4" strokeWidth={1.5} />
      {busy ? "A exportar…" : label}
    </button>
  );
}
